export default "__VITE_ASSET__0826a164__"